// require all files in dir
const context = require.context('./', true, /\.(mp3)$/)
context.keys().forEach(context)